<div class="breadcrumb">
    <div class="container">
        <a routerLink="/">Home</a> > {{ 'Prescrições Pendentes de Validação' | translate}}
    </div>
</div>

<main class="container">
    <h1 i18n>{{ 'Prescrições Pendentes de Validação' | translate}}</h1>

    <div class="producao_button" *ngIf="isAdminUser">
        <button class="red_button padding" (click)="abrirModalGerarCsv()" i18n>
            {{ 'Gerar arquivo de captura eletrônica' | translate}}
        </button>
    </div>

    <div class="filtros">
        <div class="filtro">
            <label for="status" i18n>{{ 'Status' | translate}}</label>
            <select id="status" [(ngModel)]="filtro.status">
                <option value="" i18n>{{ 'Todos' | translate}}</option>
                <option *ngFor="let status of listaStatus" [value]="status">{{switchString(status) | translate}}</option>
            </select>
        </div>
        <div class="filtro">
            <label for="status" i18n>{{ 'País' | translate}}</label>
            <select id="status" [(ngModel)]="filtro.country">
                <option value="" i18n>{{ 'Todos' | translate}}</option>
                <option *ngFor="let pais of listaPaises" [value]="pais.id">{{pais.name}}</option>
            </select>
        </div>
        <!--div class="filtro">
            <label for="status">Cidade</label>
            <select id="status" [(ngModel)]="filtro.cidade">
                <option value="">Todos</option>
                <option *ngFor="let status of listaCidades" [value]="status">{{status}}</option>
            </select>
        </div-->
        <div class="filtro">
            <label for="status" i18n>{{ 'PDV' | translate}}</label>
            <input type="text" [formControl]="pdvControl" [matAutocomplete]="autoPdv" [(ngModel)]="filtro.pdv" class="name_size" />

            <mat-autocomplete #autoPdv="matAutocomplete">
                <mat-option *ngFor="let pdvItem of pdvFiltrado | slice:0:5" [value]="pdvItem">
                {{ pdvItem | lowercaseCustom }}
                </mat-option>
                <mat-option *ngIf="pdvFiltrado.length === 0" i18n disabled>
                {{ 'Sem sugestões' | translate}}
                </mat-option>
            </mat-autocomplete>

            <!--select id="status" [(ngModel)]="filtro.pdv">
                <option value="" i18n>{{ 'Todos' | translate}}</option>
                <option *ngFor="let status of listaPDVs" [value]="status">{{status}}</option>
            </select-->
        </div>
        <div class="filtro">
            <label for="status" i18n>{{ 'Ano' | translate}}</label>
            <select id="status" [(ngModel)]="filtro.ano">
                <option value="" i18n>{{ 'Todos' | translate}}</option>
                <option *ngFor="let status of listaAno" [value]="status">{{status}}</option>
            </select>
        </div>
        <div class="filtro">
            <label for="status" i18n>{{ 'Mês' | translate}}</label>
            <select id="status" [(ngModel)]="filtro.mes">
                <option value="" i18n>{{ 'Todos' | translate}}</option>
                <option *ngFor="let status of listaMes" [value]="status">{{status}}</option>
            </select>
        </div>
        <div class="filtro">
            <label for="status" i18n>{{ 'Envio' | translate}}</label>
            <select id="status" [(ngModel)]="filtro.envio">
                <option value="" i18n>{{ 'Todos' | translate}}</option>
                <option *ngFor="let status of listaEnvio" [value]="status">{{status}}</option>
            </select>
        </div>
        <div class="filtro">
            <label for="status" i18n>{{ 'Região' | translate}}</label>
            <select id="status" [(ngModel)]="filtro.regiao">
                <option value="" i18n>{{ 'Todos' | translate}}</option>
                <option *ngFor="let status of listaRegiao" [value]="status.id">{{status.name}}</option>
            </select>
        </div>
        <div class="filtro">
            <label for="status">{{ 'Provedor' | translate}}</label>
            <select id="status" [(ngModel)]="filtro.provedor">
                <option value="" i18n>{{ 'Todos' | translate}}</option>
                <option *ngFor="let status of listaProvedor" [value]="status">{{status}}</option>
            </select>
        </div>
        <div class="filtro" *ngIf="isAdminUser">
            <label for="status">{{ 'Responsável' | translate}}</label>
            <select id="status" [(ngModel)]="filtro.responsavel">
                <option value="">{{ 'Todos' | translate}}</option>
                <option *ngFor="let status of listaGrupos" [value]="status.id">{{status.name}}</option>
            </select>
        </div>
        <div class="filtro">
            <label for="status" i18n>{{ 'Data Leitura' | translate}}</label>
            <input type="date" id="data" [(ngModel)]="filtro.dataf">
        </div>
        <!--div class="filtro">
            <label for="status">{{ 'Busca por nome de arquivo' | translate}}</label>
            <input type="text" [formControl]="searchControl" [matAutocomplete]="autoFilename" [(ngModel)]="filtro.filename" class="name_size" />

            <mat-autocomplete #autoFilename="matAutocomplete">
                <mat-option *ngFor="let filenameItem of filenameFiltrado | slice:0:5" [value]="filenameItem">
                {{ filenameItem | lowercaseCustom }}
                </mat-option>
                <mat-option *ngIf="filenameFiltrado.length === 0" i18n disabled>
                {{ 'Sem sugestões' | translate}}
                </mat-option>
            </mat-autocomplete>
        </div-->
        <div class="filtro">
            <label>{{ 'Revisor' | translate }}</label>
            <select [(ngModel)]="filtro.revisado" (change)="onRevisorChange()">
                <option value="">{{ 'Todos' | translate }}</option>
                <option *ngFor="let revisor of listaRevisores" [value]="revisor">{{ revisor }}</option>
            </select>
        </div>
        <div class="filtro">
            <label>{{ 'Arquivo Imagem Receita' | translate }}</label>
            <input type="text" [formControl]="filenameImagemControl" class="name_size" placeholder="{{ 'Buscar...' | translate }}" />
        </div>
        <div class="filtro">
            <label>&nbsp;</label>
            <button (click)="atualizaFiltro()" class="red_button">{{ 'Consultar' | translate }}</button>
        </div>
        <div class="filtro">
            <label i18n>{{ 'Limpar filtros' | translate}}</label>
            <button (click)="limparFiltro()" class="red_button" i18n>{{ 'Limpar' | translate}}</button>
        </div>
    </div>

    <div *ngIf="selecionarTodosShow" class="button-group">
        <!--button (click)="acao1()" class="dark_button">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
        </button-->
        
        <div class="select">
            <select [(ngModel)]="filtro.grupos">
                <option value="" i18n>{{ 'Selecionar' | translate}}</option>
                <option *ngFor="let status of listaGrupos" [value]="status.id">{{status.name}}</option>
            </select>
            <button (click)="changeGroup()" class="light_button" i18n>{{ 'Atribuir' | translate}}</button>
        </div>
    </div>

    <table border="0" cellpadding="0" cellspacing="0">
    <thead>
        <tr>
            <th *ngIf="isAdminUser">
                <input type="checkbox" [(ngModel)]="filtro.selecionarTodos" (change)="toggleSelecionarTodos()" *ngIf="!ehInbtegrado" />
            </th>
            <th i18n>#</th>
            <th i18n>{{ 'Status' | translate}}</th>
            <th i18n>{{ 'País' | translate}}</th>
            <th i18n>{{ 'PDV' | translate}}</th>
            <th i18n>{{ 'Ano' | translate}}</th>
            <th i18n>{{ 'Mês' | translate}}</th>
            <th i18n>{{ 'Envio' | translate}}</th>
            <th i18n>{{ 'Região' | translate}}</th>
            <th i18n>{{ 'Provedor' | translate}}</th>
            <th i18n>{{ 'Data Leitura' | translate}}</th>
            <th i18n>{{ 'Data Revisão' | translate}}</th>
            <!-- <th i18n *ngIf="isAdminUser">{{ 'Responsável' | translate}}</th> -->
            <th i18n>{{ 'Revisor' | translate}}</th>
            <th i18n>{{ 'Ações' | translate}}</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor='let item of listaShowItens | paginate: { itemsPerPage: pageSize, currentPage: currentPage, totalItems: filtro.revisado ? listaShowItens.length : allLoadedItems.length }; let i = index'>
            <td *ngIf="isAdminUser">
                <div *ngIf="item.status != 'P' && item.status != 'I'">
                    <input type="checkbox" [(ngModel)]="item.selecionado" (change)="atualizaSelecionado(item)" />
                </div>
            </td>
            <td>
                {{ (currentPage - 1) * pageSize + i + 1 }}
            </td>
            <td class="min90">
                {{switchString(item.status) | translate}}
            </td>
            <td>
                {{getCountry(item.pais)}}
            </td>
            <!--td>
                {{item.cidade}}
            </td-->
            <td>
                {{item.pdv}}
            </td>
            <td>
                {{item.ano}}
            </td>
            <td>
                {{item.mes}}
            </td>
            <td>
                {{item.envio}}
            </td>
            <td>
                {{getRegionName(item.regiao)}}
            </td>
            <td>
                {{item.provedor}}
            </td>
            <td>
                {{item.dataLeitura | date:'dd/MM/yyyy'}}
            </td>
            <td>
                {{item.dataRevisao | date:'dd/MM/yyyy'}}
            </td>
            <td>
                {{ item.revisado }}
            </td>
            <td>
                <a class="light_button" [ngClass]="item.sendoAcessado ? 'display_contents' : 'none'" title="{{ 'Receita sendo acessada por outro usuário' | translate}}">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
                </a>

                <a (click)="editarReceita(item)" class="light_button" title="{{ 'Acessar prescrição' | translate}}" [ngClass]="item.sendoAcessado ? 'none' : ''">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 14.66V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5.34"></path><polygon points="18 2 22 6 12 16 8 16 8 12 18 2"></polygon></svg>
                </a>

                <!--a class="dark_button" *ngIf="item.status != 'P' && item.status != 'I'">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
                </a-->

                <a class="dark_button" title="{{ 'Liberar receita para edição' | translate}}" (click)="liberarEdicao(item)" *ngIf="isAdminUser" [ngClass]="item.sendoAcessado ? 'display_contents' : 'none'">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 9.9-1"></path></svg>
                </a>

                <!--a class="red_button" *ngIf="item.status != 'P' && item.status != 'I'" title="Enviar para captura" (click)="liberarEdicao(item)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 11 12 14 22 4"></polyline><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path></svg>
                </a-->
            </td>
        </tr>
    </tbody>
    </table>

    <div class="text-center pagination">
        <pagination-controls (pageChange)="onPageChange($event)" previousLabel="" nextLabel=""></pagination-controls>
        <div class="pagination-info">
            <span>{{ 'Página' | translate}}</span> {{currentPage}} <span i18n>{{ 'de' | translate}}</span> {{arredondar((filtro.revisado ? listaShowItens.length : allLoadedItems.length) / pageSize)}} - {{ 'total de itens' | translate}}: {{filtro.revisado ? listaShowItens.length : totalItems}}
        </div>
    </div>

    <div class="loader-container" *ngIf="loading">
        <div class="spinner"></div>
        <p i18n>{{ 'Carregando' | translate}}...</p>
    </div>
</main>

<!-- Modal -->
<div class="modal" tabindex="-1" role="dialog" *ngIf="isModalOpen">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header flex space-between">
          <h5 class="modal-title" i18n>{{ 'Confirmação' | translate}}</h5>
          <button type="button" class="close" aria-label="Close" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
            <p i18n>{{ 'Tem certeza que deseja enviar para captura eletrônica?' | translate}}<br>
                {{ 'Essa ação não poderá ser alterada.' | translate}}</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" (click)="sendCaptura()" i18n>{{ 'Enviar' | translate}}</button>
          <button type="button" class="btn btn-secondary" (click)="closeModal()" i18n>{{ 'Cancelar' | translate}}</button>
        </div>
      </div>
    </div>
</div>

<!-- Modal Gerar arquivo por período -->
<div class="modal" tabindex="-1" role="dialog" *ngIf="isGerarCsvModalOpen">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header flex space-between">
          <h5 class="modal-title" i18n>{{ 'Gerar arquivo por período' | translate}}</h5>
          <button type="button" class="close" aria-label="Close" (click)="fecharModalGerarCsv()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
            <div class="filtros">
                <div class="filtro">
                    <label for="gerarCsvMes" i18n>{{ 'Mês' | translate}}</label>
                    <select id="gerarCsvMes" [(ngModel)]="gerarCsvMes" (change)="onFiltroGerarCsvChange()">
                        <option value="" i18n>{{ 'Selecione' | translate}}</option>
                        <option *ngFor="let m of listaMesesGeracaoCsv" [value]="m.value">{{ m.label | translate }}</option>
                    </select>
                </div>
                <div class="filtro">
                    <label for="gerarCsvPais" i18n>{{ 'País' | translate}}</label>
                    <select id="gerarCsvPais" [(ngModel)]="gerarCsvCountryCode" (change)="onFiltroGerarCsvChange()">
                        <option value="" i18n>{{ 'Todos' | translate}}</option>
                        <option *ngFor="let pais of listaPaises" [value]="pais.countryCode">{{pais.name}}</option>
                    </select>
                </div>
            </div>
            <p class="info-quantidade-rxs" *ngIf="gerarCsvMes && gerarCsvContagem !== null">
                {{ 'Receitas encontradas' | translate }}: {{ gerarCsvContagem }}
            </p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" [disabled]="!gerarCsvMes" (click)="confirmarGerarCsv()" i18n>{{ 'Confirmar' | translate}}</button>
          <button type="button" class="btn btn-secondary" (click)="fecharModalGerarCsv()" i18n>{{ 'Cancelar' | translate}}</button>
        </div>
      </div>
    </div>
</div>

<!-- Modal Resultado Gerar arquivo por período -->
<div class="modal" tabindex="-1" role="dialog" *ngIf="isGerarCsvResultModalOpen">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header flex space-between">
          <h5 class="modal-title" i18n>{{ 'Sucesso' | translate}}!</h5>
          <button type="button" class="close" aria-label="Close" (click)="fecharModalResultadoGerarCsv()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
            <p i18n>{{ 'Arquivo(s) gerado(s)' | translate}}:</p>
            <ul class="lista-arquivos-gerados">
                <li *ngFor="let item of gerarCsvResultados">
                    <span>{{ item.filename }}</span>
                    <button type="button" class="light_button" (click)="downloadFile(item.pais, item.bytes, item.filename)" i18n>{{ 'Baixar' | translate}}</button>
                </li>
            </ul>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="fecharModalResultadoGerarCsv()" i18n>{{ 'Fechar' | translate}}</button>
        </div>
      </div>
    </div>
</div>